import JSZip from "jszip";

export type PresignedZipEntry = { url: string; relative_path: string };

export async function downloadZipFromPresignedEntries(
  entries: PresignedZipEntry[],
  filename: string,
): Promise<{ ok: true } | { ok: false; message: string }> {
  if (entries.length === 0) {
    return { ok: false, message: "No files in folder" };
  }

  if (
    entries.length === 1 &&
    entries[0].relative_path.toLowerCase().endsWith(".zip")
  ) {
    const link = document.createElement("a");
    link.href = entries[0].url;
    link.download = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return { ok: true };
  }

  const zip = new JSZip();

  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i];
    let res: Response | null = null;
    let lastErr: Error | null = null;
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        res = await fetch(entry.url);
        if (res.ok) break;
        lastErr = new Error(`Failed to fetch ${entry.relative_path}`);
      } catch (e) {
        lastErr = e instanceof Error ? e : new Error(String(e));
      }
      await new Promise((r) => setTimeout(r, 500 * (attempt + 1)));
    }
    if (!res || !res.ok) {
      return {
        ok: false,
        message: lastErr?.message || `Failed to fetch ${entry.relative_path}`,
      };
    }
    const blob = await res.blob();
    zip.file(entry.relative_path, blob);
  }

  const zipBlob = await zip.generateAsync({ type: "blob" });
  const url = window.URL.createObjectURL(zipBlob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return { ok: true };
}
